import _                     from 'underscore';
import classNames            from 'classnames';
import React                 from 'react';
import { DropdownItemProps } from 'semantic-ui-react';

export interface UseSemanticToolsHooks {
	blockDropdownRenderLabeling( label: DropdownItemProps, hideObjects?: boolean ): DropdownItemProps
}

export const useSemanticTools = (): [ UseSemanticToolsHooks ] => {
	
	let blockDropdownRenderLabeling: UseSemanticToolsHooks['blockDropdownRenderLabeling'] = ( label, hideObjects = true ) => {
		
		return ( {
			as:        'div',
			color:     'black',
			basic:     true,
			content:   <span>{ label.text }</span>,
			className: classNames( {
				'display--hidden': hideObjects ? _.isObject( label.text ) : false,
				'no-border':       true,
			} ),
			style:     {
				display:        'flex',
				justifyContent: 'space-between',
				boxShadow:      'inset 0 0 0 1px rgba(39,41,43,.05)',
			}
		} )
	};
	
	return [
		{
			blockDropdownRenderLabeling
		}
	]
};
